export function isEmpty(value) {
  return value === null || value === undefined || value === "";
}

export function formatTs(ts) {
  if (!ts) return "-";
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? String(ts) : d.toLocaleString();
}

export function formatValue(value) {
  if (isEmpty(value)) return "-";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

// multipart / part may come on the stage itself or inside the table row data
export function pick(stage, key) {
  const v = stage?.[key] ?? stage?.data?.[key];
  return isEmpty(v) ? "-" : formatValue(v);
}

export function formatDateString(input, withTime = false) {
  const date = new Date(input);
  if (isNaN(date)) return "";

  const options = {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(withTime && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };

  return new Intl.DateTimeFormat("en-IN", options).format(date);
}
